module.exports = __webpack_public_path__ + "fonts/Brygada_1918-400-latin-ext5.d96d5f4.woff2";